import { ReactNode, createContext } from "react";
import { emptyPurchaseOrder, IPurchaseOrder } from "../../../../types/purchaseOrder.types";
import { getPurchaseOrderById, updatePurchaseOrder } from "../../../../common/services/purchaseOrder.api";
import { useQuery } from "@tanstack/react-query";

type InitialStateType = {
  purchaseOrder: IPurchaseOrder | undefined;
  isLoading: boolean;
  isError: boolean;
  savePurchaseOrder: (data: IPurchaseOrder) => Promise<{
    ok: boolean;
    data: IPurchaseOrder;
    errors: [{
      message: string;
      path: string[];
    }];
  }>
}

const initialState: InitialStateType = {
  purchaseOrder: undefined,
  isLoading: true,
  isError: false,
  savePurchaseOrder: () => Promise.reject({
    ok: false,
    data: emptyPurchaseOrder(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}

/* eslint-disable react-refresh/only-export-components */
export const PurchaseOrderDashboardContext = createContext(initialState);

type Props = {
  children: ReactNode,
  purchaseOrderId: string
}

export function PurchaseOrderDashboardProvider(props: Props) {

  const { data: purchaseOrder, isLoading, isError } = useQuery({
    queryKey: ["purchaseOrder", props.purchaseOrderId],
    queryFn: async () => {
      const result = await getPurchaseOrderById(props.purchaseOrderId);
      if (!result.ok) {
        throw new Error("Error fetching purchase order");
      }
      return result.data as IPurchaseOrder;
    },
    enabled: !!props.purchaseOrderId,
  });

  async function savePurchaseOrder(dataToSave: IPurchaseOrder) {
    try {
      const { ok, data, errors } = await updatePurchaseOrder(dataToSave);

      return { ok, data: data as IPurchaseOrder, errors: errors as [{ message: string, path: string[] }] };
    } catch (err) {
      console.log(err);
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { purchaseOrder, savePurchaseOrder, isLoading, isError }
  return (
    <PurchaseOrderDashboardContext.Provider value={theState as InitialStateType}>
      {props.children}
    </PurchaseOrderDashboardContext.Provider>
  )
}